import Swiper, { Lazy, Navigation } from "swiper";
import GoogleMap from "../utils/map";

const SinglePortfolio = {
  init() {
    SinglePortfolio.related();

    const mapEl = $("#map-wrap");
    if (mapEl.length) {
      SinglePortfolio.renderMap(mapEl);
    }
  },

  related() {
    const slider_dom = $(".related-slider");
    if (!slider_dom.length) {
      return;
    }

    const wrap = slider_dom.closest(".related-content");

    const nav_prev = wrap.find(".swiper-button-prev");

    const nav_next = wrap.find(".swiper-button-next");

    new Swiper(slider_dom[0], {
      spaceBetween: 30,
      loop: true,
      modules: [Lazy, Navigation],
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
      },
      navigation: {
        prevEl: nav_prev[0],
        nextEl: nav_next[0],
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        900: {
          slidesPerView: 2,
        },
      },
    });
  },

  renderMap(mapEl) {
    const location = {
      lat: mapEl.data("lat"),
      lng: mapEl.data("lng"),
    };

    let zoom = parseInt(mapEl.data("zoom"));
    if (!zoom) {
      zoom = 16;
    }

    const pin = mapEl.data("pin");

    let map = new google.maps.Map(mapEl[0], {
      center: location,
      zoom: zoom,
      disableDefaultUI: false,
      scrollwheel: false,
      draggable: true,
      styles: GoogleMap.styles,
    });

    map.markers = [];

    let center = new google.maps.LatLng(location.lat, location.lng);
    let marker_options = {
      position: center,
      map: map,
      clickable: false,
      animation: google.maps.Animation.DROP,
    };

    if (pin) {
      marker_options.icon = pin;
    }

    let marker = new google.maps.Marker(marker_options);
    map.markers.push(marker);
  },
};

export default SinglePortfolio;
